import React, {useEffect, useState} from "react";
import SimpleLineIcon from "react-simple-line-icons";
import "./Login.scss";
import 'toasted-notes/src/styles.css';
import {LoginRequest, MessageHandler, Validation, fixNumbers, getMallWithSubDomain} from "../../Services";
import {useHistory } from "react-router-dom";
import Logo from '../../assets/images/logo.png';
import {useLocation} from "react-router";
import useWindowDimensions from "../../hooks/useWindowDimensions";




function Login() {



    //hooks
    const history = useHistory();
    const location = useLocation();

    // states
    const [mobile,setMobile] = useState("");
    const [loginState,setLoginState] = useState(false);
    const [showLogo,set_showLogo] = useState(false);
    const [btnState,setBtnState] = useState(true);
    const [subMall,set_subMall] = useState(null);
    const [suggestParsed,setSuggestParsed] = useState([]);
    const [suggestSwitch,setSuggestSwitch] = useState(false)
    const [suggest,setSuggest] = useState([
        {mobile:"09123658985"},
        {mobile:"0912345543"},
        {mobile:"0915467777"},
        {mobile:"0918345554"}
        ]);



    // Login Method -------------------------------------------------------------------
     const Login_Request = async () => {
         if(loginState){return }
         // pre request
         setLoginState(true);

         if (!Validation({type:"MOBILE",val:fixNumbers(mobile)})){
             MessageHandler({type:"VALIDATION",status:"MOBILE"})
             setLoginState(false);
             return ;
         }

         //request
         try{
             let response = await LoginRequest({
                 phone:fixNumbers(mobile),
                 host_name:window.location.hostname
             })

             //post success request
             setLoginState(false);

             //set Mobile to Suggestion
             let suggestion_obj = [];
             let suggestion_storage = localStorage.getItem("mobileSuggestion");
             if(suggestion_storage){
                 suggestion_obj = JSON.parse(suggestion_storage);
             }

             //Check Suggestion Exist
             let exist = suggestion_obj.find(item=>item.mobile===fixNumbers(mobile))
             if(!exist){
                 suggestion_obj.push({mobile:fixNumbers(mobile)})
             }
             localStorage.setItem("mobileSuggestion",JSON.stringify(suggestion_obj))

             //clear
             if(location.state && location.state.mall){
                 history.push("/verify",{
                     token:response.data.token,
                     mobile:mobile,
                     mall:location.state.mall,
                     loginState:location.state
                 })
                }
             else {
                 if(subMall){
                     history.push("/verify",{
                         token:response.data.token,
                         mobile:mobile,
                         mall:subMall,
                         loginState:location.state
                     })
                 }else {
                     history.push("/verify",{token:response.data.token,mobile:mobile,loginState:location.state})
                 }
             }

             MessageHandler({type:"LOGIN",status:"SUCCESS"})
         }catch (e) {
             //post failed request
             // console.log(e)
             setLoginState(false);
             MessageHandler({type:"LOGIN",status:"ERROR"})
         }
    }

    const updateWindowDimensions = () => {
        if(window.innerHeight<380){
            setBtnState(false)
        }else {
            setBtnState(true)
        }
    }

    useEffect(()=>{
        //check subdomain
        // let full = window.location.hostname; // subdomain.domain.com
        // let parts = full.split('.');
        // let sub = parts[0];
        //
        // if(sub==="www" || sub==="test")
        //     sub = parts[1];
        //
        // if(sub==="digimaall" || sub==="test" || sub==="stage" || sub==="localhost" || sub==="apluss"  || sub==="app"){
        //     sub = "digimaall"
        // }

        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if(parts.length===3 && parts[0]!=="www"){
            sub = parts[0]
        }else{
            sub = "app"
        }

        isAdmin = parts[0];

        if(isAdmin==="www" || isAdmin==="test")
            isAdmin = parts[1];

        if(isAdmin==="digimaall" || isAdmin==="test" || isAdmin==="stage" || isAdmin==="localhost" || isAdmin==="apluss"  || isAdmin==="app"){
            let temp = isAdmin;
            isAdmin = "digimaall";
            if(temp==="app" && parts[1] !== "apluss"){
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }
        }

        if(isAdmin!=="digimaall"){
            getMall(sub)
        }else {
            set_showLogo(true)
        }

    },[])

    const getMall = async (sub)=>{
        try {
            const res_getMall = await getMallWithSubDomain(sub);
            console.log("mall : ",res_getMall)
            set_subMall(res_getMall.data)
            set_showLogo(true)
        }
        catch (e) {
            console.log(e)
            set_showLogo(true)
        }
    }


    useEffect(()=>{
         console.log("State : ",location)
        window.addEventListener('resize',updateWindowDimensions);
        let suggestion_storage = localStorage.getItem("mobileSuggestion");
        if(suggestion_storage){
            let suggestion_parsed = JSON.parse(suggestion_storage);
            setSuggestParsed(suggestion_parsed)
        }

        return () => {window.addEventListener('resize',updateWindowDimensions)}
    },[])

    const onEnter = (event, callback) => event.key  === 'Enter' && callback()
    const enterEvent = () => Login_Request();

    const doSuggest = (val) =>{
        if(val===""){
            setSuggest([])
            setSuggestSwitch(false)
            return false;
        }
        //sug list
        if(suggestParsed.length>0){
            let result =  suggestParsed.filter(item=>item.mobile.search(fixNumbers(val))>-1);
            if(result.length>0){
                setSuggest(result)
                setSuggestSwitch(true)
            }else {
                setSuggest([])
                setSuggestSwitch(false)
            }
        }
    }


    const { height, width,mobileWidth } = useWindowDimensions();

    return(
        <div className="login-container">
            <div className="otp-container">
                {/*<span onClick={()=>history.push("/scan")}>SCAN</span>*/}

                <div className="otp-top">
                    {/*{showLogo ? <div className="otp-logo">*/}
                    {/*    {subMall && subMall.logo ? <img src={subMall.logo} alt={subMall.name}/> :*/}
                    {/*        <img src={Logo} alt="Digi Mall"/>}*/}
                    {/*</div> : null}*/}


                    <h2>{subMall?.name}</h2>

                    <div className="otp-message">
                        <div className="otp-message">
                            <span>برای ورود یا ثبت نام شماره موبایل خود را وارد نمائید :</span>
                        </div>
                    </div>
                </div>

                <div className="otp-input">
                    <input
                        value={mobile}
                        onChange={(e) => {
                            setMobile(e.target.value)
                            doSuggest(e.target.value)
                        }}
                        onKeyPress={e => onEnter(e, enterEvent)}
                        autoComplete="off"
                        pattern="[0-9]*"
                        inputMode="numeric"
                        type="text" name="mobile" id="mobile" placeholder="شماره موبایل"/>
                    <SimpleLineIcon name="screen-smartphone"/>
                    {suggestSwitch ? <div className="suggest-list">
                        {suggest.slice(0, 3).map(item => {
                            return (
                                <div className="suggest-list-item" onClick={() => {
                                    setMobile(item.mobile)
                                    setSuggest([])
                                    setSuggestSwitch(false)
                                }}>
                                    <span>{item.mobile}</span>
                                </div>
                            )
                        })}
                    </div> : null}
                </div>


                <div className="static-login-btn" onClick={Login_Request}>
                    {loginState ? <i className="fa fa-spinner fa-spin"></i> : <img src="/other/arrow-left.png" alt=""/>}
                    ورود
                    <span style={{fontSize: 17}}></span>
                </div>


                {/*{btnState?<div className="top-float-send-btn" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>*/}
                {/*    <div className="float-btn" onClick={Login_Request}>*/}
                {/*        {loginState?<i className="fa fa-spinner fa-spin"></i>: <img src="/other/arrow-left.png" alt=""/>}*/}
                {/*        ورود*/}
                {/*        <span style={{fontSize:17}}></span>*/}
                {/*    </div>*/}
                {/*</div>:null}*/}


            </div>
        </div>
    )
}

export {Login}

